module.exports = __webpack_public_path__ + "img/linkedin.3e2cd069.svg";